import React, { useContext, useState } from "react";
import { AuthContext, AuthProvider } from "./AuthContext";
import webSocketService from "./WebSocketService";
import RegistrationPage from "./RegistrationPage";
import LoginPage from "./LoginPage";
import Dashboard from "./Dashboard";
import "./App.css"; // CSS for styling

const AppContent = () => {
  const { user } = useContext(AuthContext);
  const [isLogin, setIsLogin] = useState(true); // State to toggle between Login and Register

  if (user) {
    const email = localStorage.getItem("email")
    webSocketService.send({ command: "set_user",email: email })
    return <Dashboard />;
  }


  return (
    <div className={`container ${isLogin ? "show-login" : "show-register"}`}>
      <div className="form-container">
        {isLogin ? (
          <LoginPage
            onLoggedIn={() => window.location.reload()}
          />
        ) : (
          <RegistrationPage onRegistered={() => setIsLogin(true)} />
        )}
      </div>
      <p>
        {isLogin ? "Don't have an account?" : "Already have an account?"}{" "}
        <span onClick={() => setIsLogin(!isLogin)}>
          {isLogin ? "Register" : "Login"}
        </span>
      </p>
    </div>
  );
};

const App = () => {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
};

export default App;
